import React from 'react';
import * as VKConnect from '@vkontakte/vkui-connect';
import { ConfigProvider, View, Group, Div, Panel, PanelHeader, Button, Root, Footer, Link, Alert } from '@vkontakte/vkui';

import { isWebView } from '@vkontakte/vkui/src/lib/webview';
import '@vkontakte/vkui/dist/vkui.css';

import './style.css';

import Home from './panels/Home';
import MoreGid from './panels/MoreGid';
import Result from './panels/Result';

import result_obj from './scan';

var app_id = 6671467;
var ad_gid   = 39599132;

class App extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			error: '',
			activeView: 'main',
			activePanel: 'home',
			activeTab: 'groups',
			fetchedGroupsApi: [],
			fetchedUser: {},
			target: {},
			result: {},
			AdGroupInfo: {},
			access_token: null,
			scope: null,
			rand: 1,
			send: false,
			fixed_post: false,
			popout: null,
		};

	}

componentDidMount()	{

	//Первые запросы к ВК коннект
	VKConnect.send('VKWebAppInit', {});
	VKConnect.send('VKWebAppGetUserInfo', {});

	window.location = "#home";
	window.onpopstate = () => {
		let dl = String(document.location);
		let ld = dl.split('#')[1];
		switch ( ld ) {
			case 'moreGid':
				this.setState({ 
					activePanel: 'moreGid',
				});
			break;
			case 'result':
				this.setState({ 
					activePanel: 'result',
				});
			break;
			case 'home':
				this.setState({ 
					activePanel: 'home',
				});
			break;
			default:
				//window.location = "#home";
		}	
	}

	//Подписываемся на события ВК коннект
	VKConnect.subscribe((e) => {
		if (Object.keys(e.detail).length > 0) {
			switch (e.detail.type) {
				case 'VKWebAppUpdateConfig':
					document.body.setAttribute("scheme", e.detail.data.scheme);
				break;
				case 'VKWebAppJoinGroupResult': //пользователь подписался на сообщество.
					if (e.detail.data.result) {
						//тут мы выводим алерт
						this.setState({ popout:
							<Alert
								actions={[{
									title: 'Хорошо',
									autoclose: true,
									style: 'cancel'
								}]}
								onClose={ () => this.setState({ popout: null }) }
							>
								<h2>Отлично!</h2>
								<p>Вы подписались на сообщество.</p>
							</Alert>
						});

						this.setState({
							AdGroupInfo: {
								is_member: 1
							},
						});	
					}
				break;
				case 'VKWebAppAllowMessagesFromGroupResult': //пользователь разрешил отправлять себе сообщения от имени группы
					if (e.detail.data.result) {
						this.setState({
							AdGroupInfo: {
								is_messages_blocked: 0
							},
						});
						this.sendTemplatePhoto();
					}
				break;
				case 'VKWebAppAccessTokenFailed': //токен НЕ получен.
					
					this.setState({
						activeView: 'welcome',
					});
					
				break;
				case 'VKWebAppAccessTokenReceived': //токен получен.
					this.setState({
						access_token: e.detail.data.access_token,
						activeView: 'main',
						scope: e.detail.data.scope,
					});
					this.GetAllUserGroups();
				break;
				case 'VKWebAppGetUserInfoResult':
					this.setState({
						fetchedUser: {
							...e.detail.data 
						},
					});
				break;
				case 'VKWebAppCallAPIMethodFailed':
					if (e.detail.data.error_data) {
						switch (e.detail.data.error_data.error_code) {
							case 3: //соединение с интернетом потеряно.
								this.setState({ 
									activeView: 'no_internet'
								});
							break;
							default:
						}
					}
				break;
				case 'VKWebAppCallAPIMethodResult': //Ответы на запросы методов АПИ ВК

					switch (e.detail.data.request_id) { //сортируем ответы по request_id
						case 'GetAllUserGroups':
							this.setState({
								fetchedGroupsApi: e.detail.data.response.items,
							});
							this.GetAdGroupInfo();
						break;
						case 'GetAdGroupInfo':
							this.setState({
								AdGroupInfo: e.detail.data.response[0],
							});
						break;
						case 'GetTargetGroupInfo':

							if (this.state.activeView !== 'main') { //меняем на мейн если до этого была ошибка интернета.
								this.setState({ 
									activeView: 'main'
								});
							}


							if (e.detail.data.response[0].can_message === 1) {
								this.GetTargetOnlineStatus();
							} else {
								this.GetTargetWall();
							}

							result_obj.set.can_message(e.detail.data.response[0]);
							result_obj.set.cover(e.detail.data.response[0]);
							result_obj.set.market(e.detail.data.response[0]);
							result_obj.set.type(e.detail.data.response[0]);
							result_obj.set.screen_name(e.detail.data.response[0]);
							result_obj.set.age_limits(e.detail.data.response[0]);
							result_obj.set.description(e.detail.data.response[0]);
							result_obj.set.main_section(e.detail.data.response[0]);
							result_obj.set.links(e.detail.data.response[0]);
							result_obj.set.contacts(e.detail.data.response[0]);
							
							//Получаем ид закреплённой записи записываем в стейт
							if (e.detail.data.response[0].fixed_post) {
								this.setState({ fixed_post: e.detail.data.response[0].fixed_post });
							}

							this.setState({ rand: Math.random() });
						break;
						case 'GetTargetWall':
							result_obj.set.GetTargetWall(e.detail.data.response, this.state.fixed_post, this.state.target);
							this.setState({ rand: Math.random() });
						break;
						case 'GetTargetOnlineStatus':
							this.GetTargetWall();
							result_obj.set.online(e.detail.data.response);
							this.setState({ rand: Math.random() });
						break;
						default:
							this.setState({
								error: e.detail,
							});
					}
				break;
				default:
					this.setState({
						error: e.detail,
					});	
			}
		}
	});

	
	if (localStorage.getItem('welcome')) { //Проверка на то видел ли пользователь окно приветствия. 
		this.setState({ 
			activeView: 'main'
		});
		this.GetToken();
	} else {
		this.setState({ 
			activeView: 'welcome'
		});
		localStorage.setItem('welcome', true);
	}

}



	GetTargetWall = () => {
		VKConnect.send("VKWebAppCallAPIMethod", { //Запрос на получение записей со стены в сообществе.
			"method": "wall.get",
			"request_id": "GetTargetWall",
			"params": {
				"owner_id": '-'+this.state.target.id,
				"offset":0,
				"count":100,
				"extended":1,
				"fields":"",
				"v":"5.131", 
				"access_token":this.state.access_token
			}
		});
	}


	GetTargetOnlineStatus = () => {
		VKConnect.send("VKWebAppCallAPIMethod", { //Запрос на получение статуса онлайн в сообществе.
			"method": "groups.getOnlineStatus",
			"request_id": "GetTargetOnlineStatus",
			"params": {
				"group_id": this.state.target.id,
				"v":"5.131", 
				"access_token":this.state.access_token
			}
		});
	}



	GetAdGroupInfo = () => {
		VKConnect.send("VKWebAppCallAPIMethod", {
			"method": "groups.getById",
			"request_id": "GetAdGroupInfo",
			"params": {
				"group_id": ad_gid,
				"fields": "members_count,is_messages_blocked",
				"v":"5.131", 
				"access_token":this.state.access_token
			}
		});
	}

	GetAllUserGroups = () => {
		VKConnect.send("VKWebAppCallAPIMethod", {
			"method": "groups.get",
			"request_id": "GetAllUserGroups",
			"params": {
				"user_id": this.state.fetchedUser.id,
				"extended": 1,
				"fields" : "members_count,description,activity,verified",
				"v":"5.131", 
				"access_token":this.state.access_token
			}
		});
	}

	targetData = (value) => { //функция смены выбранной группы
		this.setState({ 
			target: value,
			send: false, 
		});
	}

	SkipResult = () => {
		result_obj.skipresult();
	}

	SetActivePanel = (value) => { //функция смены выбранной панели
		//result_obj.skipresult(); //при переходе скидываем все полученные значения в false.
		this.setState({ 
			activePanel: value,
		});
		window.location = "#"+value;
	}

	SetActiveTab = (value) => {
		this.setState({ 
			activeTab: value
		});
	}
	

	SetSend = (gid, uid, points) => {
		if (this.state.send !== true) {
			let json_data = {
				command: "set_data",
				gid:gid,
				uid:uid,
				points:points,
			};

	          fetch('https://smm-yugova.ru/aj/to.php', {
	            method: 'post',
	            headers: {
	              'Accept': 'application/json, text/plain, */*',
	              'Content-Type': 'application/x-www-form-urlencoded'
	            },
	            body: 'data=' + encodeURIComponent(JSON.stringify(json_data))
	            })
	            .then(function (response) {
	              return response;
	            })
	            .then(function(data) {})
	            .catch (function (error) {});

			this.setState({ 
				send: true,
			});
	    }
	}

	sendTemplatePhoto = () => {
		if (this.state.AdGroupInfo.is_messages_blocked !== 0) {
			VKConnect.send("VKWebAppAllowMessagesFromGroup", { "group_id": 39599132 });
		} else {
			this.sendTemplate(this.state.fetchedUser.id);
		}
	}

	sendTemplate = (uid) => {
			let json_data = {
				command: "send_message",
				uid:uid,
				url: window.location.search
			};

	          fetch('https://smm-yugova.ru/aj/to.php', {
	            method: 'post',
	            headers: {
	              'Accept': 'application/json, text/plain, */*',
	              'Content-Type': 'application/x-www-form-urlencoded'
	            },
	            body: 'data=' + encodeURIComponent(JSON.stringify(json_data))
	            })
	            .then(function (response) {
					return response;
	            })
	            .then((data) => {

				this.setState({ popout:
					<Alert
						actions={[{
							title: 'Хорошо',
							autoclose: true,
							style: 'cancel'
						}]}
						onClose={ () => this.setState({ popout: null }) }
					>
						<h2>Отлично!</h2>
						<p>Шаблон отправлен Вам в личку.</p>
					</Alert>
				});

	            })
	            .catch (function (error) {});
	}

	GetToken = () => {
		VKConnect.send("VKWebAppGetAuthToken", {"app_id": app_id, "scope": "groups"}); //groups
	}

	GetResult = () => { //функция запросов к серверу ВК
		VKConnect.send("VKWebAppCallAPIMethod", { //Запрос на получение общей информации.
			"method": "groups.getById",
			"request_id": "GetTargetGroupInfo",
			"params": {
				"group_id": this.state.target.id,
				"fields": "members_count,can_message,cover,market,links,age_limits,description,main_section,fixed_post,contacts,counters",
				"v":"5.131", 
				"access_token":this.state.access_token
			}
		});

		this.setState({ 
			result: result_obj,
		});
	}

	render() {
		return (
		<ConfigProvider isWebView={isWebView}>
			<Root activeView={this.state.activeView}>
				<View popout={this.state.popout} id="main" activePanel={this.state.activePanel}>
					
					<Home 
					scope={this.state.scope}
					GetToken={this.GetToken}
					id="home" 
					targetData={this.targetData} 
					SetActivePanel={this.SetActivePanel}
					fetchedGroupsApi={this.state.fetchedGroupsApi}
					fetchedUser={this.state.fetchedUser}
					activeTab={this.state.activeTab}
					SetActiveTab={this.SetActiveTab}
					error={this.state.error}/>
					
					<MoreGid 
					id="moreGid" 
					targetGid={this.state.target} 
					SetActivePanel={this.SetActivePanel}
					GetResult={this.GetResult}
					SkipResult={this.SkipResult}/>

					<Result 
					rand={this.state.rand}
					id="result"
					SetActivePanel={this.SetActivePanel}
					result={this.state.result}
					targetGid={this.state.target}
					AdGroupInfo={this.state.AdGroupInfo}
					fetchedUser={this.state.fetchedUser}
					SetSend={this.SetSend}
					sendTemplatePhoto={this.sendTemplatePhoto}
					error={this.state.error}
					/>

				</View>

				<View id="welcome" activePanel='welcome_screen'>
					<Panel id="welcome_screen">
						<PanelHeader>SMM Анализ</PanelHeader>
						<Group title={<span>Здравствуйте, {this.state.fetchedUser.first_name}!</span>}>
							<Div className="mt0" >
								Этот сервис сделан для анализа коммерческих сообществ ВКонтакте, чтобы Вы смогли без труда найти недочеты в сообществе и подкорректировать их.
							</Div>
							<Div className="mt0">
								Вы можете проанализировать свое сообщество или проанализировать любое сообщество, на которое Вы подписаны.
							</Div>
							<Div className="mt0">
								Для правильной работы приложения необходим доступ к списку Ваших групп.
							</Div>
							<Div className="mt0">
								<Button size="xl" onClick={this.GetToken}>Хорошо</Button>
							</Div>
						</Group>
						<Footer>
							<Link target="_blank" className="CustomLink" href="https://vk.com/club39599132">Группа</Link>
							<Link target="_blank" className="CustomLink" href="https://vk.com/@kupiapp-servis-smm-analiz">О приложении</Link>
						</Footer>
					</Panel>
				</View>

				<View id="no_internet" activePanel='ups'>
					<Panel id="ups">
						<PanelHeader>SMM Анализ</PanelHeader>
						
						<Div className="mt12"><center><b>Интернет-соединение потеряно</b></center></Div>
						<Div className="mt0"><center>Попробуйте повторить попытку позднее</center></Div>
							<Div className="mt0">
								<center>
									<Button className="mt12" onClick={
										() => {
											this.SkipResult()
											this.GetResult()
											this.SetActivePanel('result')
										}
									}>
										Повторить попытку
									</Button>
								</center>
							</Div>
						
					</Panel>
				</View>

			</Root>
		</ConfigProvider>
		);
	}

}

export default App;


// WEBPACK FOOTER //
// ./src/App.js